(() => {
  window.ACReferenceModules = window.ACReferenceModules || {};
  if (window.ACReferenceModules.appReveal) return;
  window.ACReferenceModules.appReveal = true;
  const selector = '[data-ac-app-reveal]';
  const offscreen = 'scroll-trigger--offscreen';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  const pending = new Set();
  let observer;

  const reduced = () => motion.matches || document.body.dataset.acMotion === 'reduced';
  const targets = (root) => [
    ...(root.matches?.(selector) ? [root] : []),
    ...root.querySelectorAll(selector),
  ];

  const show = (element, cancel = false) => {
    observer?.unobserve(element);
    pending.delete(element);
    element.classList.remove(offscreen);
    if (cancel) element.classList.add('scroll-trigger--cancel');
  };

  const initialize = (root = document, editorEvent = false) => {
    for (const element of targets(root)) {
      if (editorEvent || reduced() || !window.IntersectionObserver) {
        if (editorEvent) element.classList.add('scroll-trigger--design-mode');
        show(element, true);
        initialized.add(element);
        continue;
      }
      if (initialized.has(element)) continue;
      initialized.add(element);
      observer ||= new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!pending.has(entry.target)) continue;
          if (reduced()) show(entry.target, true);
          else if (entry.isIntersecting) show(entry.target);
          else entry.target.classList.add(offscreen);
        }
      }, { rootMargin: '0px 0px -50px 0px' });
      pending.add(element);
      observer.observe(element);
    }
  };

  const syncMotion = () => {
    if (reduced()) targets(document).forEach((element) => show(element, true));
  };

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => initialize(event.target, true));
    document.addEventListener('shopify:section:reorder', () => initialize(document, true));
    document.addEventListener('shopify:section:unload', (event) => {
      for (const element of targets(event.target)) {
        observer?.unobserve(element);
        pending.delete(element);
        initialized.delete(element);
      }
    });
  }

  const boot = () => {
    initialize();
    motion.addEventListener('change', syncMotion);
    new MutationObserver(syncMotion).observe(document.body, {
      attributes: true,
      attributeFilter: ['data-ac-motion'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else boot();
})();
